import { useNavigate } from "react-router-dom";
import { ChevronRight, Home, ArrowLeft } from "@/components/icons";

export default function Crumbs({ items = [], backTo, backLabel = "Voltar", testId = "crumbs" }) {
  const navigate = useNavigate();
  const voltar = () => {
    if (backTo) navigate(backTo);
    else navigate(-1);
  };
  return (
    <div className="flex items-center gap-2 flex-wrap mb-3" data-testid={testId}>
      <button
        onClick={voltar}
        data-testid={`${testId}-voltar`}
        className="inline-flex items-center gap-1 h-11 md:h-9 px-3 rounded-lg bg-white border border-slate-200 text-sm font-medium text-navy hover:bg-slate-50 transition-colors"
      >
        <ArrowLeft className="w-4 h-4" /> {backLabel}
      </button>
      <nav className="flex items-center gap-1 text-xs text-muted-foreground">
        <button
          onClick={() => navigate("/")}
          className="flex items-center gap-1 hover:text-navy"
          data-testid={`${testId}-home`}
        >
          <Home className="w-3.5 h-3.5" /> Início
        </button>
        {items.map((it, i) => (
          <span key={i} className="flex items-center gap-1">
            <ChevronRight className="w-3.5 h-3.5" />
            {it.to ? (
              <button
                onClick={() => navigate(it.to)}
                className="hover:text-navy"
                data-testid={`${testId}-item-${i}`}
              >
                {it.label}
              </button>
            ) : (
              <span
                className="text-navy font-medium"
                data-testid={`${testId}-item-${i}`}
              >
                {it.label}
              </span>
            )}
          </span>
        ))}
      </nav>
    </div>
  );
}
